module.exports = __webpack_public_path__ + "img/nodata.27f4c997.png";